export default __webpack_public_path__ + "static/media/Logo.f06c9900.svg";